import styled from 'styled-components'


export const Containerfluid = styled.div`
    width: 100%;
    background: url('images/banner_interior.png') #000;
    border-bottom: #00B3E0 solid 13px;
    padding-bottom: 20px;
    @media (min-width: 768px) {
      
        padding-bottom: 120px;
    
    }
    @media (min-width: 992px) {
        
        padding-bottom: 120px;
        
    }
    @media (min-width: 1200px) {
        
        padding-bottom: 120px;
        
    }
`

export const Container = styled.div`
    padding-right: 10px;
    padding-left: 10px;
    margin-right: auto;
    margin-left: auto;
    @media (min-width: 768px) {
        padding-right: 0px;
        padding-left: 0px;
        width: 750px;
    }
    @media (min-width: 992px) {
        padding-right: 0px;
        padding-left: 0px;
        width: 970px;
        
    }
    @media (min-width: 1200px) {
        padding-right: 0px;
        padding-left: 0px;
        width: 1110px;
        
    }
`


export const LogoContainer = styled.div`
    width: 100%;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    @media (min-width: 768px) { 
        font-size: 14px;
        margin-top: 20px;
    }
    @media (min-width: 992px) { 
        font-size: 14px;
        margin-top: 20px;
    }
    @media (min-width: 1200px) { 
        font-size: 18px;
        align-self: flex-start;
        align-items: flex-start;
        flex:2
        margin-top: 20px;
    }
    

    a{
        display: flex
    }

    .contentmovile{
        display:flex;
        flex-direction:row;
        justify-content: space-between;
        align-items: flex-start;

        
    }
    @media (min-width: 768px) { 
        font-size: 14px;
        .contentmovile{
            justify-content: flex-start;
            align-items:center;
        }
    }
    @media (min-width: 992px) { 
        font-size: 14px;
        .contentmovile{
            justify-content: flex-start;
            align-items:center;
        }
    }
    @media (min-width: 1200px) { 
        font-size: 18px;
        align-self: flex-start;
        align-items:flex-start;
        .contentmovile{
            justify-content: flex-start;
            width: 100%;
        }
    }
`

export const Logo = styled.img`
    width: 200px;
    height:49px;
    margin-bottom: 10px;
    
    @media (min-width: 768px) { 
        width: auto;
        height:auto;
        margin-bottom: 20px;
    }
    @media (min-width: 992px) { 
        width: auto;
        height:auto;
        margin-bottom: 20px;
    }
    @media (min-width: 1200px) { 
        width: auto;
        height:auto;
        align-self: flex-start;
        margin-bottom: 20px;
    }
`

export const Claim = styled.div`
    width: 100%;
    font-size: 16px;
    font-family: 'Open Sans', sans-serif;
    font-weight: 300;
    color: #fff;
    display:block;
    @media (min-width: 768px) { 
        font-size: 34px;
        display:block;
        
    }
    @media (min-width: 992px) { 
        font-size: 34px;
        display:block;
    }
    @media (min-width: 1200px) { 
        font-size: 40px;
        display:block;
    }
    @media (min-width: 1400px) { 
        font-size: 42px;
        display:block;
    }
`


export const Row = styled.div`
    display: flex;
    flex-direction: column;
    align-items: initial;

    @media (min-width: 768px) { 
        flex-direction: column;
    }
    @media (min-width: 992px) { 
        flex-direction: column;
    }
    @media (min-width: 1200px) { 
        flex-direction: row;
        width: 100%;
        justify-content: flex-end;
        flex:1
    }

    > div{
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
`
export const Icons = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-right: 10px;

    @media (min-width: 768px) { 
        flex-direction: row;
    }
    @media (min-width: 992px) { 
        flex-direction: row;
        margin-right: 0px;
    }
    @media (min-width: 1200px) { 
        flex-direction: row;
        width: 50%;
    }
`
export const User = styled.div`
    display: inline-block;
    align-items: center;
    margin-left: 20px;
    justify-content: flex-end;
    width:auto;
    @media (min-width: 768px) { 
        margin-top: 25px;
    }
    @media (min-width: 992px) { 
        margin-top: 25px;
    }
    @media (min-width: 1200px) { 
        margin-top: 0px;
        align-self: flex-end;
        justify-self: self-end;
        width: auto;
    }
`
export const Name = styled.div`
    color: #4D4F5C;
    font-size: 20px;
    width:100%;
    @media (min-width: 768px) { 
        font-size: 20px;
    }
    @media (min-width: 992px) { 
        font-size: 16px;
    }
    @media (min-width: 1200px) { 
        font-size: 16px;
    }
`
export const Logout = styled.div`
    margin-left: 20px;
    cursor: pointer;
    color: #92999F;
    margin: 5px 0 0 20px;

    &:hover{
        color: #000;
    }
`

export const ContainerBrowswe = styled.div`
    display:flex;
    text-align:right;
    align-items: center;

    .cont{
        display:flex;
        justify-content:center;
        align-items:center;
    }
`

export const Agenda = styled.a`
    margin-left: 20px;
    cursor: pointer;
    color: #92999F;
    margin: 5px 0 0 20px;
    display: inline-block;
   

    &:hover{
        color: #000;
    }

    img{
        width:28px;
        margin-right: 10px
    }
`



